import React, { useContext, useEffect, useState } from 'react';
import withAppState, { IAppStateComponentProps } from '../state/withAppState';
import { AppState } from '../state/AppStateGate';
import { isFlagEnabled } from '../utils/flag';

type Props = IAppStateComponentProps & {
  flagName: string;
  context?: Record<string, unknown>;
};
export function useFeatureFlag(flagName: string, context?: Record<string, unknown>): boolean {
  const appStateContext = useContext(AppState);
  const [isEnabled, setIsEnabled] = useState<boolean>(false);
  useEffect(() => {
    const checkFlag = async () => {
      const response = await isFlagEnabled(flagName, {
        userId: appStateContext?.appState?.user?.id,
        customerId: appStateContext?.appState?.user?.customerId,
        ...(context || {}),
      });
      setIsEnabled(response);
    };
    checkFlag();
  }, []);
  return isEnabled;
}

export function useFeatureFlagNoContext(flagName: string, context?: Record<string, unknown>): boolean {
  const [isEnabled, setIsEnabled] = useState<boolean>(false);
  useEffect(() => {
    const checkFlag = async () => {
      const response = await isFlagEnabled(flagName, context);
      setIsEnabled(response);
    };
    checkFlag();
  }, []);
  return isEnabled;
}
